import React from 'react';
import { Checkbox } from '@Thread-Magic/jasmine';
import LinkButton from '../../../components/LinkButton';
import RankStars from '../components/RankStars';
import { NoValuesDescription, CompanyCheckBoxWrap } from './PartnerQueueClient.style';
import AppIcon from '../components/AppIcon';

export const columns = ({ checkedCompanies, handleCheckCompany, handleCompanyNameClick }) => [
  {
    key: 'company_name',
    title: 'Name',
    isSort: false,
    component: row => (
      <CompanyCheckBoxWrap key={row.company_id}>
        <Checkbox
          id={`company-checkbox-${row.company_id}`}
          checked={checkedCompanies.includes(row.company_id)}
          onChange={() => handleCheckCompany(row.company_id)}
        />
        <LinkButton className="company-link-btn" onClick={() => handleCompanyNameClick(row)}>
          {row.company_name}
        </LinkButton>
      </CompanyCheckBoxWrap>
    )
  },
  {
    key: 'type',
    title: 'Type',
    isSort: false
  },
  {
    key: 'thread_usage',
    title: 'Req. 90d',
    isSort: false,
    component: row =>
      row.thread_usage === 0 ? <NoValuesDescription>N/A</NoValuesDescription> : row.thread_usage
  },
  {
    key: 'teams_usage',
    title: 'Teams usage',
    isSort: false,
    component: row =>
      row.teams_usage === 0 ? <NoValuesDescription>N/A</NoValuesDescription> : row.teams_usage
  },
  {
    key: 'is_messenger_enabled',
    title: 'Messenger',
    component: row => (row.is_messenger_enabled ? 'Enabled' : 'Disabled'),
    isSort: false
  },
  {
    key: 'is_magic_ai_enabled',
    title: 'Magic AI',
    component: row => (row.is_magic_ai_enabled ? 'Enabled' : 'Disabled'),
    isSort: false
  },
  {
    key: 'app',
    title: 'Apps',
    component: row =>
      row.app.length === 0 ? (
        <NoValuesDescription>N/A</NoValuesDescription>
      ) : (
        row.app.split(',').map(app => <AppIcon app={app.trim()} />)
      ),
    isSort: false
  },
  {
    key: 'rank',
    title: 'Rank',
    component: row => <RankStars rank={row.rank} />,
    isSort: false
  }
];
